/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarModelDtoFromJSON, CarModelDtoToJSON, } from './';
export function CarMakeWithModelsDtoFromJSON(json) {
    return CarMakeWithModelsDtoFromJSONTyped(json, false);
}
export function CarMakeWithModelsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'makeName': !exists(json, 'makeName') ? undefined : json['makeName'],
        'models': !exists(json, 'models') ? undefined : (json['models'] === null ? null : json['models'].map(CarModelDtoFromJSON)),
    };
}
export function CarMakeWithModelsDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'makeName': value.makeName,
        'models': value.models === undefined ? undefined : (value.models === null ? null : value.models.map(CarModelDtoToJSON)),
    };
}
